import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 30px 50px 50px 50px;
  border-radius: 4px;
  box-shadow: 0 2px 50px 0 rgba(0, 0, 0, 0.03);
  background-color: ${({ theme }) => theme.backgrounds.agentsWrapper};
`;
Wrapper.displayName = 'Wrapper';

export const AgentsWrapper = styled.div`
  width: 100%;
`;
AgentsWrapper.displayName = 'AgentsWrapper';

export const Title = styled.div`
  user-select: none;
  font-size: 21px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.24;
  letter-spacing: normal;
  color: #1c2243;
`;
Title.displayName = 'Title';
